module.exports = __webpack_public_path__ + "static/media/iconAgrupamento.9751cb1d.svg";